var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.426,
    height: 16.359,
    viewBox: "0 0 18.426 16.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke-linejoin:round;}.a,.b{stroke:#646464;stroke-linecap:round;stroke-width:1.5px;}.b,.d{fill:none;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 7.314,
    cy: 7.314,
    r: 7.314
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 7.314,
    cy: 7.314,
    r: 6.564
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.224.23,4.815,3.806",
    transform: "translate(12.558 11.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.22989702a3ea4953c36cafc92bdebe6e.svg";
export { ForwardRef as ReactComponent };